/** User-facing product name. Keep `apps/desktop/index.html` title in sync. */
export const APP_NAME = 'Achakan';
export const APP_TAGLINE = 'Retail ERP';
export const APP_LOGO_LETTER = 'A';
